var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-left-filter",class:_vm._f("rtlTextClass")(_vm.locale)},[_c('el-row',[_c('span',{staticClass:"filter-title"},[_vm._v(_vm._s(_vm.$t('filter.category.label')))]),_vm._v(" "),_c('category-select')],1),_vm._v(" "),_c('dynamic-fields')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-192f8ee3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainLeftFilters/LeftFilter.vue
// module id = 1398
// module chunks = 6